<script lang="ts">
  export let contentClass = '';
  export let hasMaxWidth = true;
</script>

<main class="content-wrapper {contentClass}" class:has-max-width={hasMaxWidth}>
  <slot />
</main>

<style lang="scss">
  @use '../styles/spacing';

  .content-wrapper {
    flex: 1;
    margin: 0 auto;
    width: 100%;
    padding: spacing.$s;
    box-sizing: border-box;

    &.has-max-width {
      max-width: 1280px;
    }
  }

  .login-content-wrapper {
    background-color: #eef0f2;
    text-align: center;
  }
</style>
